import axios from '../../../libs/axios';
import { AuthUser } from '../types';

export interface RegisterRequest {
  mobile: string;
  password: string;
}

export interface RegisterResponse {
  status: number;
  msg: string;
  data: AuthUser;
}

export const register = (data: RegisterRequest): Promise<RegisterResponse> => {
  return axios.post('/auth/register', data);
};
